import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAuthState } from '../../interfaces/state.interfaces';

const initialState: IAuthState = {
    accessToken: null,
    expirationTime: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        SetAccessToken(state, action: PayloadAction<string | null>) {
            state.accessToken = action.payload;
        },
        SetAccessTokenExpirationTime(state, action: PayloadAction<number | null>) {
            state.expirationTime = action.payload;
        },
        SetAuthInitialState(state) {
            state.accessToken = null;
            state.expirationTime = null;
        },
    },
});

export const { SetAccessToken, SetAccessTokenExpirationTime, SetAuthInitialState } =
    authSlice.actions;

export const authReducer = authSlice.reducer;
